import { render, staticRenderFns } from "./TransferResidentInputModal.vue?vue&type=template&id=dc15b5dc&lang=pug"
import script from "./TransferResidentInputModal.vue?vue&type=script&lang=ts"
export * from "./TransferResidentInputModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports